'use client';
import React, { useEffect } from 'react';

import useGsapLoaded from '@src/hooks/useGsapLoaded';

import SectionHeader from '@src/components/Shared/SectionHeader';
import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';
import RenderButtons from '@src/components/Shared/RenderButtons';

import { HumanTrakVideoPropTypes } from './HeroParallax.types';

export default function HeroParallax({ className, data }: HumanTrakVideoPropTypes) {
  const isGsapLoaded = useGsapLoaded();

  useEffect(() => {
    if (isGsapLoaded) {
      const isMobile = window.innerWidth < 768;

      const animationOptions = {
        backgroundPosition: '100% 100%',
        duration: isMobile ? 20 : 60,
        ease: 'none',
        repeat: -1, // Infinite repeat
      };

      window?.gsap?.killTweensOf('.parallax');

      window?.gsap.to('.parallax', animationOptions);
    }
  }, [isGsapLoaded]); // Depend on isGsapLoaded

  return (
    <>
      <div className={`relative ${className}`}>
        <div
          className='parallax absolute top-0 z-[-1] h-[55rem] w-full opacity-[0.3] lg:h-[70rem]'
          style={{
            backgroundImage: `url(${data?.mediaPrimary?.url})`,
            backgroundSize: '100% auto',
            backgroundRepeat: 'repeat-y',
            backgroundPosition: '0% 0%',
          }}
        ></div>
        <div className='flex h-[55rem] flex-col items-center justify-center text-wrap lg:h-[70rem]'>
          <div className='mx-auto my-auto max-h-[50rem] w-[90%] max-w-[82rem] rounded-4xl bg-[#FFFFFF] p-[2rem] opacity-[0.9] shadow-[0_4px_20px_0_rgba(0,0,0,0.25)] md:w-[80%] md:p-[4rem] xl:w-[63%]'>
            <SectionHeader
              className='h-full'
              preTitleClassName='mb-[1.6rem] sm:text-center'
              pretitle={data?.preTitle}
              title={data?.title}
              titleClassName='text-center text-[2.2rem] text-left! w-full! mx-auto lg:max-w-[61rem] leading-[2.6rem] tracking-[-0.0418] text-body-copy--dark font-light text-[1.8rem] sm:text-center! md:leading-[3rem] md:text-[2.8rem] lg:text-[4.8rem] lg:leading-[5rem]'
              childrenClassName='relative 2xl:max-w-[unset]!'
            >
              <RenderBodyCopy
                className='text-body-copy--dark mt-[2.4rem] text-left font-extralight text-balance sm:text-center md:mx-auto 2xl:mt-[3.2rem]'
                bodyCopy={data?.bodyCopy?.json?.content}
              />
              <RenderButtons className='justify-center' items={data?.buttonCollection?.items} />
            </SectionHeader>
          </div>
        </div>
      </div>
    </>
  );
}
